export default (props, vars) => () => vars?.['usestate15']?.['setState'](true);
